import { supabase } from "@/lib/supabase";

export const PhotoEstimationService = {
  async estimate(imageUrl: string): Promise<{ result?: string; error?: string }> {
    const { data, error } = await supabase.functions.invoke("estimate-photo-dimensions", {
      body: { imageUrl },
    });
    if (error) return { error: error.message ?? "Estimation failed" };
    const result = (data as { result?: string } | null)?.result;
    return { result: result ?? "Unable to estimate from this photo." };
  },
};
